import React from "react";
import { theme } from "../../utils/theme";
import { useTour } from "@reactour/tour";

// import { useDispatch } from "react-redux";

const Popup = ({ onClose }) => {
  const { setIsOpen } = useTour();
  // const dispatch = useDispatch();
  return (
    <div className="popup">
      <div className="fixed z-40 h-[100vh] w-[100vw] bg-[rgba(0,0,0,0.2)] backdrop-blur-sm flex items-center justify-center">
        <div className="flex flex-col items-end ">
          <div className="m-[20px] grid divide-y-2 bg-white shadow-md rounded-lg overflow-hidden">
            <div
              style={{ backgroundColor: theme.color }}
              className="p-[20px] text-white text-base sm:text-lg xl:text-2xl text-center 2xl:text-3xl"
            >
              Do You Want a Walk-Through of this App?
            </div>
            <div className="flex items-center justify-center">
              <div className="m-[10px] btn">
                <button
                  onClick={() => {
                    setIsOpen(true);
                    onClose();
                  }}
                  style={{ backgroundColor: theme.color }}
                  className="text-white m-[20px] rounded-md px-[15px] w-fit py-[10px] flex cursor-pointer"
                >
                  Yes
                </button>
              </div>
              <div className="m-[10px] btn">
                <button
                  onClick={() => {
                    onClose();
                  }}
                  style={{ backgroundColor: theme.color }}
                  className="text-white m-[20px] rounded-md px-[15px] w-fit py-[10px] flex cursor-pointer"
                >
                  No
                </button>
              </div>
            </div>
            <div className="Note m-[5px] flex items-center justify-center">
              Note: You can always take a user tour later from the settings
              page.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Popup;
